<template>
  <public-layout>
    <template slot="main">
      <div class="w-full flex flex-col min-h-full dark:bg-staticdarkblue-900">
        <div class="flex flex-grow items-center justify-center mt-10">
          <div class="w-full max-w-sm relative">
              <div class="flex flex-row">
                <base-logo :filename="logo" alt="EdasInvoiZE" class="mx-auto mb-6 w-logo brand"/>
              </div>
              <div>
                <div v-if="isFirstLogin">
                  <FirstLoginForm
                    @cleanToggleForms="cleanToggleForms" 
                    @activeLoginOTPConfig="activeLoginOTPConfig" 
                    @activeLoginOTP="activeLoginOTP"/>
                </div>
                <div v-else-if="isLoginOTP">
                  <OtpLoginForm
                    @cleanToggleForms="cleanToggleForms" />
                </div>
                <div v-else-if="isLoginOTPConfig">
                  <OtpConfigForm 
                    @cleanToggleForms="cleanToggleForms" 
                    @activeLoginOTP="activeLoginOTP"/>
                </div>
                <div v-else-if="isLogin">
                  <el-form
                    @submit.prevent.native="submitLoginForm()"
                    class="px-4 sm:px-0"
                    :model="loginForm"
                    :rules="loginRules"
                    ref="loginForm"
                    novalidate
                  >
                    <div>
                      <el-form-item prop="email">
                        <el-input
                          :placeholder="$t('noauth.user_or_email_placeholder')"
                          type="email"
                          class="mb-2 custom__icons static-css"
                          clearable
                          v-model="loginForm.email"
                          maxlength='255'
                          :disabled="loginType !== null"
                        >
                          <i slot="prefix" class="el-input__icon">
                            <BaseIcon size="sm" name="user" />
                          </i>
                          <el-button slot="append" icon="el-icon-edit" 
                            v-if="loginType != null"
                            @click="resetLoginType()"
                            :type="(loginType != null) ? 'submit' : 'button'"
                            :aria-label="$t('noauth.edit_and_reset_login')"
                            ></el-button>
                        </el-input>
                      </el-form-item>
                    </div>
                    <el-form-item  prop="password"
                      v-if="loginType === 'STANDARD' || loginType === 'HYBRID' || loginType === 'HYBRIDSAML2'"
                      class="mb-0"
                    >
                      <el-input
                        :placeholder="$t('noauth.password_placeholder')"
                        type="password"
                        class="mb-4 custom__icons static-css"
                        show-password
                        clearable
                        v-model="loginForm.password"
                        maxlength='50'
                      >
                        <i slot="prefix" class="el-input__icon">
                          <BaseIcon size="sm" name="lock" />
                        </i>
                      </el-input>
                    </el-form-item>
                    <div v-if="loginType && !(isFirstLogin || isLoginOTP || isLoginOTPConfig)">
                      <div class="flex items-center justify-end ">
                        <span class="block text-sm font-semibold text-staticprimary-800 dark:text-staticdarkblue-200 cursor-pointer hover:text-staticprimary"
                          @click="switchForm()"
                        >{{$t('noauth.forgot_pass')}}</span>
                      </div>
                    </div>
                    <base-button
                      v-if="[SubmitType.LOGIN, SubmitType.MIXTO_AAD, SubmitType.MIXTO_SAML2].includes(submitType)"
                      class="w-full"
                      mode="staticprimary"
                      :text="$t('noauth.common_access')"
                      :loading = "loader"
                      :type="([SubmitType.LOGIN].includes(submitType) || ([SubmitType.MIXTO_AAD, SubmitType.MIXTO_SAML2].includes(submitType) && loginForm.password)) ? 'submit' : 'button'"
                      @click="([SubmitType.LOGIN].includes(submitType) || ([SubmitType.MIXTO_AAD, SubmitType.MIXTO_SAML2].includes(submitType) && loginForm.password)) ? empty() : doLogin('loginForm')"
                      
                    />
                    <div class=" px-4 sm:px-0">
                      <base-button
                        v-if="[SubmitType.LOGIN_TYPE].includes(submitType)"
                        class="w-full mt-4"
                        mode="staticprimary"
                        :text="$t('app.next')"
                        :loading="loader"
                        :type="[SubmitType.LOGIN_TYPE].includes(submitType) ? 'submit' : 'button'"
                        @click="[SubmitType.LOGIN_TYPE].includes(submitType) ? empty() : handleGetLogInType('loginForm')"
                        />
                      <base-button 
                        v-if="[SubmitType.AAD, SubmitType.MIXTO_AAD].includes(submitType)"
                        class="w-full mt-4"
                        mode="staticprimary"
                        :text="$t('noauth.microsoft_access')"
                        icon="microsoft"
                        :loading="loader"
                        :type="[SubmitType.AAD].includes(submitType) ? 'submit' : 'button'"
                        @click="[SubmitType.AAD].includes(submitType) ? empty() : logInMicrosoft()"
                      />
                      <base-button 
                        v-if="[SubmitType.SAML2, SubmitType.MIXTO_SAML2].includes(submitType)"
                        class="w-full mt-4"
                        mode="staticprimary"
                        :text="$t('noauth.saml2_access')"
                        icon="sso"
                        :loading="loader"
                        :type="[SubmitType.SAML2].includes(submitType)"
                        @click="[SubmitType.SAML2].includes(submitType) ? empty() : logInSAML2()"
                      />
                    </div>
                  </el-form>
                </div>
                <div v-else>
                  <el-form
                    @submit.prevent.native="doReset('resetForm')"
                    class="px-4 sm:px-0"
                    :model="resetForm"
                    :rules="resetRules"
                    ref="resetForm"
                  >
                    <p class="text-sm mb-2 text-center text-secondary-600 dark:text-staticdarkblue-200">
                      {{$t('noauth.reset_label')}}
                    </p>
                  <el-form-item  prop="email">
                    <el-input
                      :placeholder="$t('noauth.register_email_placeholder')"
                      type="email"
                      class="mb-4 custom__icons static-css"
                      clearable
                      v-model="resetForm.email"
                      maxlength='255'
                    >
                      <i
                        slot="prefix"
                        class="el-input__icon"
                      >
                        <base-icon name="user" />
                      </i>
                    </el-input>
                  </el-form-item>
                  <div v-if="loginType && !(isFirstLogin || isLoginOTP || isLoginOTPConfig)">
                    <div class="flex items-center justify-end ">
                      <span class="block text-sm font-semibold text-staticprimary-800 dark:text-staticdarkblue-200 cursor-pointer hover:text-staticprimary"
                        @click="switchForm()"
                      >{{ $t('noauth.back_to_login') }}</span>
                    </div>
                  </div>
                    <base-button
                      mode="staticprimary"
                      :text="$t('noauth.reset_password')"
                      class="w-full"
                      @click.prevent="doReset('resetForm')"
                      :loading = "loader"
                    />
                  </el-form>
                </div>
              </div>
            <base-logo-partner
              class="mx-auto mb-6 mt-6 w-logozc brand"
              alt="ZeroComa"
              :filename="logoPartner"/>
          </div>
        </div>
      </div>
    </template>
  </public-layout>
</template>

<script>
import PublicLayout from '@/components/layout/PublicLayout.vue'
import OtpLoginForm from '@/components/loginoptions/OtpLoginForm.vue'
import OtpConfigForm from '@/components/loginoptions/OtpConfigForm.vue'
import FirstLoginForm from '@/components/loginoptions/FirstLoginForm.vue'

import { getLoginType } from '@/services/configurations/getLoginType'

import { i18n } from '@/i18n'

const SubmitType = {
  NONE: 'none',
  LOGIN_TYPE: 'loginType',
  LOGIN: 'login',
  AAD: 'aad',
  SAML2: 'saml2',
  MIXTO_AAD: 'mixtoAad',
  MIXTO_SAML2: 'mixtoSaml2'
}

export default {
  components: { 
    PublicLayout,
    OtpLoginForm,
    OtpConfigForm,
    FirstLoginForm,
  },
  name: 'login',
  data: function () {
    return {
      SubmitType: SubmitType,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      loginForm: {
        email: '',
        password: ''
      },
      resetForm: {
        email: ''
      },
      isLogin: true,
      loader: false,

      loginType: null,
      
      isFirstLogin: false,
      isLoginOTP: false,
      isLoginOTPConfig: false,
      
      loginRules: {
        email: [
          { validator: this.isEmailValid, trigger: 'blur' }
        ],
        password: [
          { validator: this.isPasswordValid, trigger: 'blur' }
        ]
      },
      resetRules: {
        email: [
          { validator: this.isEmailRegValid, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      if (this.darkMode) {
        return 'logo-edasinvoize-dark.webp'
      }
      return 'logo-edasinvoize.webp'
    },
    logoPartner: function () {
      if (this.darkMode) {
        return 'logo-zc-dark.webp'
      }
      return 'logo-zc.webp'
    },
    submitType: function () {
      if (!this.loginType) {
        return SubmitType.LOGIN_TYPE
      }
      if (['STANDARD'].includes(this.loginType)) {
        return SubmitType.LOGIN
      }
      if (this.loginType === 'AAD') {
        return SubmitType.AAD
      }
      if (this.loginType === 'SAML2') {
        return SubmitType.SAML2
      }
      if (this.loginType === 'HYBRID') {
        return SubmitType.MIXTO_AAD
      }
      if (this.loginType === 'HYBRIDSAML2') {
        return SubmitType.MIXTO_SAML2
      }
      return SubmitType.NONE
    }
  },
  mounted: function () {
    if (this.$route.params.refreshTokenFail === true) {
      this.doFeedback(i18n.t('feedback.info.expired_session_msg'), 'info', 5000)
    }
    if (!this.loginType) {
      this.loginForm.password = ''
    }
    this.$store.commit('app/resetHaderCoreFilters')
  },
  methods: {
    cleanToggleForms () {
      this.isFirstLogin = false
      this.isLoginOTP = false
      this.isLoginOTPConfig = false
    },
    activeLoginOTP () {
      this.isLoginOTP = true
    },
    activeLoginOTPConfig () {
      this.isLoginOTPConfig = true
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      callback()
    },
    isEmailRegValid: function (rule, value, callback) {
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      if (!this.reg.test(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },
    isPasswordValid: function (rule, value, callback) {
      if (!this.loginType) {
        callback()
      }
      if (!value) {
        return callback(new Error(i18n.t('validation.complete')))
      }
      callback()
    },
    switchForm: function () {
      this.isLogin = !this.isLogin
    },
    submitLoginForm: function () {
      const formName = 'loginForm'
      if (!this.loginType) {
        this.handleGetLogInType(formName)
      } else if (this.loginType === 'AAD') {
        this.logInMicrosoft()
      } else if (this.loginType === 'SAML2') {
        this.logInSAML2()
      } else {
        this.doLogin(formName)
      }
    },
    doLogin: async function (formName) {
      const valid = await this.$refs[formName].validate()
      if (valid) {
        try {
          this.loader = true
          await this.$store.dispatch('auth/login', this.loginForm)
          // this.$store.dispatch('auth/me', false)
          await this.$store.dispatch('auth/getModules')
          await this.$store.dispatch('auth/getPermisos')
          await this.$store.dispatch('app/getAnnouncementsList')
        } catch (error) {
          if (error !== undefined && error.blnError) {
            if (error.stepCode === 0) { 
              this.isFirstLogin = true
            } else if (error.stepCode === 2) {
              this.isLoginOTPConfig = true
            } else if (error.stepCode === 3) {
              this.isLoginOTP = true
            } else {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', error))
            }
          } else {
            this.doFeedback()
          }
        } finally {
          this.loader = false
        }
      } else {
        this.doFeedback(i18n.t('feedback.error.bad_credentials_error'))
      }
    },
    doReset: function (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.loader = true
            await this.$store.dispatch('auth/recoveryPassword', this.resetForm)
            this.doFeedback(i18n.t('feedback.success.recovery_mail_sent_msg'), 'success')
            this.switchForm()
          } catch (error) {
            if (error !== undefined && error.blnError) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', error))
            } else {
              this.doFeedback()
            }
          } finally {
            this.loader = false
          }
        } else {
          this.doFeedback(i18n.t('validation.email_short'))
        }
      })
    },
    logInMicrosoft: async function () {
      this.loaderAAD = true
      try {
        this.$store.commit('aadAuth/settingUPMsal')
        await this.$store.dispatch('aadAuth/showPopUpLogin')
      } catch (error) {
        if (error !== undefined && error.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', error))
        } else {
          this.doFeedback()
        }
      } finally {
        this.loaderAAD = false
      }
    },
    logInSAML2: async function () {
      this.loader = true
      try {
        const guidSSO = this.$store.getters['aadAuth/GuidSSO']
        window.location.href = process.env.VUE_APP_API_URL + 'api/login/requestsaml2?guid=' + guidSSO
      } catch (error) {
        this.doFeedback()
      } finally {
        this.loader = false
      }
    },
    resetLoginType () {
      this.loginType = null
      this.loginForm.password = ''
    },
    handleGetLogInType: async function (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            this.loader = true
            this.loginForm.password = ''
            // Obtener datos de login
            const loginType = await getLoginType({ usernameOrEmail: this.loginForm.email })
            if (loginType.blnError) {
              throw loginType
            } else {
              this.loginType = loginType.TipoAutenticacion
              this.$store.commit('aadAuth/setClientID', loginType.ClientID)
              this.$store.commit('aadAuth/setTenantID', loginType.TenantID)
              this.$store.commit('aadAuth/setGuidSSO', loginType.Guid)
              if (this.loginType === 'AAD') this.logInMicrosoft()
              if (this.loginType === 'SAML2') this.logInSAML2()
            }
          } catch (error) {
            console.error(error)
            if (error !== undefined && error.blnError) {
              this.doFeedback(error.msgError + ' [' + error.codError + ']')
            } else {
              this.doFeedback()
            }
          } finally {
            this.loader = false
          }
        } 
      })
    },
    empty: () => { }
  }
}
</script>
<style lang="scss" scoped>
.w-logozc {
  max-width: 180px;
}
.w-logo {
  max-width: 250px;
}

.dark .el-input .el-input__inner {
  border-color: var(--staticdarkblue-600) !important;
  background-color: var(--staticdarkblue-DEFAULT) !important;
  color: var(--staticdarkblue-300) !important;
}
</style>
